import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { OrderService } from 'src/app/services/manager/order.service';
import { v4 as uuidv4 } from 'uuid';
import { DateTime } from 'luxon';
import { Order } from 'src/app/interfaces/orders';
import { DataServerService } from 'src/app/services/api/data-server.service';

@Component({
  selector: 'app-test-modal',
  templateUrl: './test-modal.component.html',
  styleUrls: ['./test-modal.component.scss'],
  standalone: false
})
export class TestModalComponent  {
  name:  string = '';
  yeet: any;

  constructor(
    private modalCtrl: ModalController,
    private order: OrderService,
    private dataServer: DataServerService
  ) {}


  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  confirm() {
    return this.modalCtrl.dismiss(this.name, 'confirm');
  }

  async getcontacts() {


  }

  createOrder() {
    //this.order.createOrder();
  }

  updateOrCreateOrder() {
    //this.order.updateOrCreateOrder();
  }

  createDummyOrder() {
        // Create new Order Id
        const uuid = uuidv4();
        const dt = DateTime.now();
        const timestamp = dt.toISO();

        let neworder: Order = {
          orderId: "xxxx",
          created: timestamp,
          updated: timestamp,
          status: 4,
          note: '',
          customerBase: null,
          customerEmail: '',
          adminEmail: '',
          products: null,
          productHistory: null,
          customerAddress: null,
        };

        this.order.updateOrCreateOrder(neworder);
      }


}
